<script setup lang="ts">
/**
 * UpdateBanner — shown when a new app version is ready to install.
 *
 * The user taps "Neu starten" to apply the update. Because the reload is
 * triggered by a user gesture, iOS PWA handles it without freezing.
 */
defineProps<{
  onUpdate: () => void
}>()
</script>

<template>
  <div class="update-banner">
    <div class="update-content">
      <i class="pi pi-sync update-icon" />
      <span class="update-text">Neue Version verfügbar</span>
    </div>
    <button
      class="update-btn"
      @click="onUpdate"
    >
      <i class="pi pi-refresh" />
      Neu starten
    </button>
  </div>
</template>

<style scoped>
.update-banner {
  position: fixed;
  top: env(safe-area-inset-top, 0px);
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.625rem 1rem;
  background: var(--color-brand-primary);
  color: var(--color-on-primary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.update-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.update-icon {
  font-size: 0.875rem;
  flex-shrink: 0;
}

.update-text {
  font-size: 0.875rem;
  font-weight: 500;
}

.update-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  background: var(--color-on-primary);
  color: var(--color-brand-primary);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}
</style>
